export const CREATE_CONTACT = `
  mutation createContact($input: CreateContactInput!, $tenant_id: Int!) {
    createContact(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Contact {
        id
        firstname
        lastname
        email
        secondary_email
        phone
        mobile
        city
        country
        country_code
        province
        plaza
        identification
        identification_type_id
        birth_date
        gender
        exclude
        timezone
        comments
        zip_code
        address
        position
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_CONTACT = `
  mutation updateContact($input: UpdateContactInput!, $tenant_id: Int!) {
    updateContact(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Contact {
        id
        firstname
        lastname
        email
        secondary_email
        phone
        mobile
        city
        country
        country_code
        province
        plaza
        identification
        identification_type_id
        birth_date
        gender
        exclude
        timezone
        comments
        zip_code
        address
        position
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_CONTACT = `
  mutation deleteContact($id: Int!, $tenant_id: Int!) {
    deleteContact(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Contact {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
